import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllTeachers() {
  return get(`${apiHost}/api/admin/users`);
}
